import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTE_MAP } from 'consts/url';

import './apartmentTypeSelector.scss';
import { PageFilterCard } from 'components/FilterCard';

const APARTMENT_SELECT = [
  {
    label: '1BR Apartment',
    url: `/${ROUTE_MAP.interior.id}/1br/overview`,
    id: `1pn`,
  },
  {
    label: '1BR+ Apartment',
    url: `/${ROUTE_MAP.interior.id}/1br-plus/overview`,
    id: `1pn-plus`,
  },
  {
    label: '2BR Apartment',
    url: `/${ROUTE_MAP.interior.id}/2br/overview`,
    id: `2pn`,
  },
  {
    label: '3BR Apartment',
    url: `/${ROUTE_MAP.interior.id}/3br/overview`,
    id: `3pn`,
  },
];

const ApartmentTypeSelector = () => {
  const isDesktop = window.innerWidth > 1180;

  if (!isDesktop) {
    return (
      <div className="selector-mobile">
        <Content />
      </div>
    );
  }

  return (
    <PageFilterCard className="apartment-type-selector">
      <Content />
    </PageFilterCard>
  );
};

const Content = () => {
  const history = useHistory();
  const { pathname } = history.location;

  return (
    <div className="apartment-selector-content">
      {APARTMENT_SELECT.map(({ label, url, id }) => {
        const isActive = pathname.split('/')[2] === id;

        return (
          <button
            key={url}
            onClick={() => history.push(`${url}`)}
            className={`apartment-option ${isActive ? 'active' : ''}`}
          >
            <span className="apartment-option-label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ApartmentTypeSelector;
